<template>
    <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            :opacity="detailsOpacity"
            fill-rule="evenodd"
            clip-rule="evenodd" 
            d="M9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17C8 16.4477 8.44772 16 9 16ZM15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9Z" 
            :fill="color"/>
        <path 
            fill-rule="evenodd" 
            clip-rule="evenodd" 
            d="M5 6V3C5 2.44772 5.44772 2 6 2H18C18.5523 2 19 2.44772 19 3V6C20.6569 6 22 7.34315 22 9V13C22 14.3872 21.0584 15.5545 19.7795 15.8977L20.7608 20.8039C20.7737 20.8685 20.7802 20.9341 20.7802 21C20.7802 21.5523 20.3325 22 19.7802 22H4.2198C4.15395 22 4.08826 21.9935 4.02369 21.9806C3.48213 21.8723 3.13091 21.3454 3.23922 20.8039L4.22046 15.8977C2.94155 15.5545 2 14.3872 2 13V9C2 7.34315 3.34315 6 5 6ZM19 8H5C4.44772 8 4 8.44772 4 9V13C4 13.416 4.25398 13.7726 4.61533 13.9233L4.83922 12.8039C4.93271 12.3365 5.34312 12 5.8198 12H18.1802C18.6569 12 19.0673 12.3365 19.1608 12.8039L19.3847 13.9233C19.746 13.7726 20 13.416 20 13V9C20 8.44772 19.5523 8 19 8ZM5.43961 20H18.5604L17.3604 14H6.63961L5.43961 20ZM7 4V6H17V4H7ZM18 9C18.5523 9 19 9.44772 19 10C19 10.5523 18.5523 11 18 11C17.4477 11 17 10.5523 17 10C17 9.44772 17.4477 9 18 9Z" 
            :fill="color"/>
    </svg>
</template>
<script>
    export default {
        props:['width','height','color','detailsOpacity'],
    }
</script>

<style scoped>
</style>
